import type { RuntimeNodeImport } from '@/models/logic/RuntimeGraphIds';
import type Context from '@/context';
import type { ITileManagerModel } from '@/interfaces/models';
import { TileManagerModel, type TileManagerDto } from '@/models/TileManagerModel';
import type { TileInstance } from '@/models/tiles/TileInstance';

export class TileManagerFactory {
  create(context: Context): ITileManagerModel {
    return new TileManagerModel(context);
  }

  fromTiles(tiles: TileInstance[], context: Context): ITileManagerModel {
    return TileManagerModel.fromTiles(tiles, context);
  }

  fromDto(
    dto: TileManagerDto,
    context: Context,
    importer?: RuntimeNodeImport,
  ): ITileManagerModel {
    return TileManagerModel.fromDto(dto, context, importer);
  }

  *fromDtoSteps(
    dto: TileManagerDto,
    context: Context,
    importer?: RuntimeNodeImport,
    onProgress?: import('@/utils/projectLoadProgress').ProjectLoadWorkObserver,
  ): Generator<void, ITileManagerModel> {
    return yield* TileManagerModel.fromDtoSteps(dto, context, importer, onProgress);
  }
}
